// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
    position: relative;
    width: 90%;
    margin: auto;
    overflow: hidden;
}

.carousel-content {
    display: flex;
}

.carousel-slide {
    min-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
}

.carousel-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: #0000007F;
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 20px;
    z-index: 1;
    border-radius: 50px;
    width: 60px;
    height: 60px;
}

.carousel-button-left {
    left: 10px;
}

.carousel-button-right {
    right: 10px;
}

.dots {
    margin: 15px;
    display: flex;
    justify-content: center;
}

.dots span {
    margin: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50px;
    background-color: #E0E0E0;
}

@media screen and (max-width: 650px) {
    .carousel-button {
        font-size: 16px;
        width: 45px;
        height: 45px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/home/css/carousel-component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".carousel {\n    position: relative;\n    width: 90%;\n    margin: auto;\n    overflow: hidden;\n}\n\n.carousel-content {\n    display: flex;\n}\n\n.carousel-slide {\n    min-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n}\n\n.carousel-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: #0000007F;\n    color: white;\n    border: none;\n    padding: 10px;\n    cursor: pointer;\n    font-size: 20px;\n    z-index: 1;\n    border-radius: 50px;\n    width: 60px;\n    height: 60px;\n}\n\n.carousel-button-left {\n    left: 10px;\n}\n\n.carousel-button-right {\n    right: 10px;\n}\n\n.dots {\n    margin: 15px;\n    display: flex;\n    justify-content: center;\n}\n\n.dots span {\n    margin: 5px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50px;\n    background-color: #E0E0E0;\n}\n\n@media screen and (max-width: 650px) {\n    .carousel-button {\n        font-size: 16px;\n        width: 45px;\n        height: 45px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
